import { Button, Flex } from '@grupoboticario/flora-react'
import { ArrowLeftIcon, ArrowRightIcon } from '@grupoboticario/flora-react-icons'

import { StepperDot, StepperIconButton, StepperNav } from './ModalTutorialNavigation.style'

const ICON_SIZE = 18

const SIZE_ICON_BUTTON = {
  height: 32,
  width: 32,
}

export interface ModalTutorialNavigationProps {
  /** Passo atual da navegação */
  currentStep?: number

  /** Total de passos */
  totalSteps: number

  /** Callback que avança para o passo anterior */
  onPrev?: () => void

  /** Callback que avança para o próximo passo */
  onNext?: () => void

  /** Callback para finalizar e fechar o tutorial */
  onSkip?: () => void
}

export const ModalTutorialNavigation = ({
  currentStep = 0,
  totalSteps = 2,
  onPrev,
  onNext,
  onSkip,
}: ModalTutorialNavigationProps) => {
  const isFirstStep = currentStep === 0
  const isLastStep = currentStep === totalSteps - 1

  return (
    <>
      <StepperNav>
        {!isFirstStep && (
          <StepperIconButton
            aria-label="Voltar"
            variant="ghost"
            onClick={onPrev}
            autotagging-flora="on"
            css={SIZE_ICON_BUTTON}
          >
            <ArrowLeftIcon size={ICON_SIZE} />
          </StepperIconButton>
        )}
      </StepperNav>

      <Flex justify="center">
        {[...Array(totalSteps)].map((_, index) => (
          <StepperDot
            key={`step-${index}`}
            active={index === currentStep}
          />
        ))}
      </Flex>

      <StepperNav>
        {isLastStep ? (
          <Button
            size="small"
            variant="standard"
            autotagging-flora="on"
            onClick={onSkip}
          >
            Finalizar
          </Button>
        ) : (
          <StepperIconButton
            aria-label="Avançar"
            variant="standard"
            onClick={onNext}
            autotagging-flora="on"
            css={SIZE_ICON_BUTTON}
          >
            <ArrowRightIcon size={ICON_SIZE} />
          </StepperIconButton>
        )}
      </StepperNav>
    </>
  )
}
